import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

function ParcelaDetalhada({ data }) {
  const { data: parcela } = data;

  const getFormattedDate = (date) => {
    const newDate = new Date(date.replace(/T.+/, ' 03:00:00.000'));
    return format(newDate, 'dd/MM/yyyy', {
      locale: ptBR,
    });
  };

  const getFormattedCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Typography variant="caption" color="secondary">
          Vencimento
        </Typography>
        <Typography variant="body2" color="secondary">
          {getFormattedDate(parcela.vencimento)}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="caption" color="secondary">
          Valor
        </Typography>
        <Typography variant="body2" color="secondary">
          {getFormattedCurrency(parcela.valor)}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="caption" color="secondary">
          Valor com desconto
        </Typography>
        <Typography variant="body2" color="secondary">
          {getFormattedCurrency(parcela.calculo)}
        </Typography>
      </Grid>
    </Grid>
  );
}

ParcelaDetalhada.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      contrato_id: PropTypes.number,
      numerocontrato: PropTypes.number,
      curso_id: PropTypes.number,
      curso: PropTypes.string,
      aluno: PropTypes.string,
      receber_id: PropTypes.number,
      tipoparcela: PropTypes.string,
      parcela: PropTypes.number,
      vencimento: PropTypes.string,
      valor: PropTypes.string,
      pago: PropTypes.bool,
      vencido: PropTypes.bool,
      linhadigitavel: PropTypes.string,
      calculo: PropTypes.string,
      status: PropTypes.string,
      pix_status: PropTypes.number,
      older: PropTypes.bool,
    }),
  }).isRequired,
};

export default ParcelaDetalhada;
